import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Moon, Layers, Sparkles, Crown, Zap, Gem, RefreshCw, Scissors, CircleDot, Phone, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Shield,
  Moon,
  Layers,
  Sparkles,
  Crown,
  Zap,
  Gem,
  RefreshCw,
  Scissors,
  CircleDot,
};

const serviceRoutes = {
  'Preventative Care': '/preventative-care',
  'Sleep Apnea Solutions': '/sleep-apnea',
  'Orthodontics': '/orthodontics',
  'Teeth Whitening': '/teeth-whitening',
  'Same-Day Crowns (CEREC)': '/cerec-crowns',
  'Porcelain Veneers': '/porcelain-veneers',
  'Emergency Dental Care': '/emergency-dental-care',
  'Restorative Dentistry': '/restorative-dentistry',
  'Oral Surgery': '/oral-surgery',
  'Dental Implants': '/dental-implants',
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon] || Shield;
  const route = serviceRoutes[service.title] || '#';

  return (
    <Link to={route}>
      <div className="group bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-cyan-200 cursor-pointer h-full">
        <div className="w-16 h-16 bg-cyan-50 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-cyan-100 transition-colors">
          <IconComponent className="text-cyan-600" size={28} />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-cyan-600 transition-colors">
          {service.title}
        </h3>
        <p className="text-gray-600 leading-relaxed text-sm">
          {service.description}
        </p>
      </div>
    </Link>
  );
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-cyan-600 font-semibold tracking-wider uppercase text-sm">
            Our Services
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-6">
            Comprehensive Dental Care
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            From preventative care to advanced cosmetic procedures, we offer a complete range of dental services to keep your smile healthy and beautiful.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>

        {/* Emergency CTA */}
        <div className="mt-16 bg-gradient-to-r from-cyan-600 to-cyan-500 rounded-2xl p-8 md:p-10 text-center">
          <p className="text-white/90 text-lg mb-2">
            Need immediate dental care? We offer same-day emergency appointments.
          </p>
          <a
            href="tel:9167731122"
            className="inline-flex items-center gap-2 text-white font-semibold text-xl hover:text-amber-300 transition-colors"
          >
            <Phone size={20} />
            <span>Call (916) 773-1122</span>
            <ArrowRight size={20} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
